import {
  GET_SUPPLIESLIST,
  GET_SUPPLIES_LOOKUP,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_SUPPLIESLIST,
  UPDATE_SUPPLIESLIST,
  DELETE_SUPPLIESLIST,
} from './actionType';

const INIT_STATE = {
  suppliesList: [],
  suppliersLookup: [],
  error: {},
  success: '',
};

const SuppliesList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SUPPLIESLIST:
          return {
            ...state,
            suppliesList: action.payload.data,
            success: '',
            error: {},
          };
        case GET_SUPPLIES_LOOKUP:
          return {
            ...state,
            suppliersLookup: action.payload.data,
            success: '',
            error: {},
          };
        case CREATE_SUPPLIESLIST:
          return {
            ...state,
            success: 'Successfully created',
            error: {},
          };
        case UPDATE_SUPPLIESLIST:
          return {
            ...state,
            success: 'Successfully updated',
            error: {},
          };
        case DELETE_SUPPLIESLIST:
          return {
            ...state,
            success: 'Successfully Deleted',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_SUPPLIESLIST:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case GET_SUPPLIES_LOOKUP:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case CREATE_SUPPLIESLIST:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case UPDATE_SUPPLIESLIST:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case DELETE_SUPPLIESLIST:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_SUPPLIESLIST: {
      return {
        ...state,
      };
    }
    case GET_SUPPLIES_LOOKUP: {
      return {
        ...state,
      };
    }
    case CREATE_SUPPLIESLIST: {
      return {
        ...state,
      };
    }
    case UPDATE_SUPPLIESLIST:
      return {
        ...state,
      };
    case DELETE_SUPPLIESLIST:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default SuppliesList;
